var map = {
	"./Skin64x64Alex.png": 3538,
	"./Skin64x64ReferenceAlex.png": 91885,
	"./Skin64x64ReferenceSteve.png": 47596,
	"./Skin64x64Steve.png": 601,
	"./SteveDiamondArmor.png": 89777,
	"./SteveDiamondArmor256.png": 54482
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8942;